module.exports = "/wp-content/plugins/farmacy/assets/js/images/title_the_menu-37f600a97b040e37c35a335f4fd19fc4.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/elo-app/img/title_the_menu.svg
 ** module id = 1011
 ** module chunks = 1 75
 **/